import { registerCommand } from '../registry';
import type { ScopedSearchCommandDef } from '../types';

/**
 * `/transcript <text>` — restrict the existing search pipeline to
 * transcript hits only. Implemented as a scoped-search command: the
 * host bridge in `GlobalMapSearch.tsx` notices the `scopedFilter`
 * and forces `activeFilter = 'transcript'` while feeding the
 * argument text through the regular `executeSearch` path. The
 * `transcripts/transcriptsSearch.ts` executor then provides the
 * actual matching logic — no duplicated filtering here.
 *
 * The scoped filter value (`'transcript'`) MUST match the category
 * key produced by `useGroupedResults.categoryFor` for transcript
 * results, otherwise the dropdown will hide every row when the
 * filter is applied.
 */
const transcriptCommand: ScopedSearchCommandDef = {
  id: 'transcript',
  kind: 'scopedSearch',
  scopedFilter: 'transcript',
  title: 'Search transcripts',
  description: 'Search live call transcriptions for matching speech.',
  usage: '<text to search>',
};

registerCommand(transcriptCommand);

export default transcriptCommand;
